import { LightbulbIcon, ZapIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  FilterToolbar,
  FilterToolbarProps,
} from '@/components/organisms/FilterToolbar/FilterToolbar';
import { FilterDefinition } from '@/components/ui/custom/ComplexFilter/ComplexFilterCombobox';

type RulesToolbarProps = Omit<FilterToolbarProps, 'searchPlaceholder' | 'filterDefinitions'>;

export const RulesToolbar = (props: RulesToolbarProps) => {
  const { t } = useTranslation();

  const filterDefinitions: FilterDefinition[] = [
    {
      id: 'status',
      label: t('rules.status'),
      icon: LightbulbIcon,
      type: 'radio',
      options: [
        { label: t('rules.active'), value: 'active' },
        { label: t('rules.inactive'), value: 'inactive' },
      ],
    },
    {
      id: 'triggeredBy',
      label: t('rules.filters.triggered_by'),
      icon: ZapIcon,
      type: 'radio',
      options: [
        { label: t('rules.filters.starting_conversation'), value: 'first_message' },
        { label: t('rules.filters.responding_to_message'), value: 'any_user_message' },
        { label: t('rules.filters.after_agent_reply'), value: 'post_message' },
      ],
    },
  ];

  return (
    <FilterToolbar
      {...props}
      searchPlaceholder={t('rules.search')}
      filterDefinitions={filterDefinitions}
      inset
    />
  );
};
